// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__23hAx","footer":"ReportModalFilter_footer__1KlOW"};